

module.exports = __webpack_require__.stylable.create(
    "o8",
    {"classes":{"root":"s314","logoLink":"s142","withImage":"s315"},"vars":{"base-font-family":"--o4-base-font-family","focus":"--o4-focus","brand-logo-link-colour":"--o4-brand-logo-link-colour"},"stVars":{},"keyframes":{}},
    "",
    2,
    8,
    null
);
